(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-custom-component"] && !Shopify.designMode) return;
  try {
    const DESKTOP_LIMIT = 5;
  const MOBILE_LIMIT = 10;

  function initFaqSection(section) {
    section.querySelector('.faq-section__footer')?.remove();
    section.querySelectorAll('.faq-section__item--hidden, .faq-section__accordion--collapsed').forEach((el) => {
      el.classList.remove('faq-section__item--hidden', 'faq-section__accordion--collapsed');
    });

    const layout = section.querySelector('.layout-section-wrapper.custom-layout-column');
    if (!layout) return;

    const isMobile = matchMedia('(max-width: 749px)').matches;
    const limit = isMobile ? MOBILE_LIMIT : DESKTOP_LIMIT;
    let hasHidden = false;

    const hideExcess = (items) => {
      items.forEach((item, index) => {
        if (index < limit) return;
        item.classList.add('faq-section__item--hidden');
        item.closest('.accordion')?.classList.add('faq-section__accordion--collapsed');
        hasHidden = true;
      });
    };

    if (isMobile) {
      hideExcess(section.querySelectorAll('accordion-custom'));
    } else {
      section.querySelectorAll('.accordion').forEach((accordion) => {
        hideExcess(accordion.querySelectorAll(':scope > accordion-custom'));
      });
    }

    if (!hasHidden) return;

    const footer = document.createElement('div');
    footer.className = 'faq-section__footer';
    footer.innerHTML =
      '<button type="button" class="faq-section__load-more" aria-expanded="false"><span class="faq-section__load-more-text">Load more</span><span class="faq-section__load-more-line" aria-hidden="true"></span></button>';
    layout.appendChild(footer);

    footer.querySelector('button').addEventListener('click', () => {
      section.querySelectorAll('.faq-section__item--hidden, .faq-section__accordion--collapsed').forEach((el) => {
        el.classList.remove('faq-section__item--hidden', 'faq-section__accordion--collapsed');
      });
      footer.remove();
    });
  }

  function initAllFaqSections() {
    document.querySelectorAll('.faq-section').forEach(initFaqSection);
  }

  initAllFaqSections();

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.querySelector('.faq-section');
    if (section) initFaqSection(section);
  });

  let faqResizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(faqResizeTimer);
    faqResizeTimer = setTimeout(initAllFaqSections, 150);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tabs-slider-snippet"] && !Shopify.designMode) return;
  try {
    function initTabsCarousel(sectionRoot) {
    const slideshow = sectionRoot.querySelector('slideshow-component[ref="tabsSlideshow"]');
    const panels = sectionRoot.querySelectorAll('[data-slide-content]');
    const dotItems = Array.from(sectionRoot.querySelectorAll('.tabs-carousel__dots li'));
    const dotsContainer = sectionRoot.querySelector('.tabs-carousel__dots');
    const autoplayToggle = sectionRoot.querySelector('[data-tabs-autoplay-toggle]');
    const slideshowContainer = slideshow?.querySelector('slideshow-container');
    const AUTOPLAY_DELAY = 6000;
    let isAutoplaying = true;
    let autoplayTimer;

    if (!slideshow || !panels.length) return;

    if (autoplayToggle && slideshowContainer && autoplayToggle.parentElement !== slideshowContainer) {
      slideshowContainer.appendChild(autoplayToggle);
    }

    function clearAutoplayTimer() {
      if (!autoplayTimer) return;
      clearTimeout(autoplayTimer);
      autoplayTimer = null;
    }

    function setAutoplayState(playing) {
      isAutoplaying = playing;
      if (!autoplayToggle) return;
      autoplayToggle.setAttribute('aria-pressed', String(playing));
      autoplayToggle.setAttribute('aria-label', playing ? 'Pause tab slider autoplay' : 'Play tab slider autoplay');
    }

    function scheduleAutoplay() {
      clearAutoplayTimer();
      if (!isAutoplaying || panels.length < 2 || !isInViewport) return;

      autoplayTimer = setTimeout(() => {
        if (typeof slideshow.next === 'function') {
          slideshow.next();
          return;
        }
        const currentIndex = typeof slideshow.current === 'number' ? slideshow.current : 0;
        const nextIndex = (currentIndex + 1) % panels.length;
      }, AUTOPLAY_DELAY);
    }

    let isInViewport = true;
    const viewportObserver = new IntersectionObserver(
      (entries) => {
        isInViewport = Boolean(entries[0]?.isIntersecting);
        if (!isInViewport) {
          clearAutoplayTimer();
          return;
        }
        scheduleAutoplay();
      },
      { threshold: 0 }
    );
    viewportObserver.observe(sectionRoot);

    function scrollActiveDotIntoView(index, smooth = true) {
      if (!isInViewport) return;
      if (!dotsContainer || !window.matchMedia('(max-width: 768px)').matches) return;
      if (dotsContainer.scrollWidth <= dotsContainer.clientWidth) return;

      const activeItem = dotItems[index];
      if (!activeItem) return;
      const right = activeItem.getBoundingClientRect(), cr = dotsContainer.getBoundingClientRect(), cw = dotsContainer.clientWidth;
      const nextLeft = Math.max(0, Math.min(dotsContainer.scrollLeft + right.left - cr.left - cw / 2 + right.width / 2, dotsContainer.scrollWidth - cw));

      dotsContainer.scrollTo({
        left: nextLeft,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }

    function setActive(index, smoothScroll = true) {
      panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      dotItems.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === index);
      });

      scrollActiveDotIntoView(index, smoothScroll);
    }

    setActive(typeof slideshow.current === 'number' ? slideshow.current : 0, false);
    setAutoplayState(true);
    scheduleAutoplay();

    autoplayToggle?.addEventListener('click', () => {
      setAutoplayState(!isAutoplaying);
      scheduleAutoplay();
    });

    slideshow.addEventListener('slideshow:select', (event) => {
      const nextIndex = event?.detail?.index;
      if (typeof nextIndex !== 'number') return;
      setActive(nextIndex);
      scheduleAutoplay();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.tabs-carousel').forEach(initTabsCarousel);
  });
  } catch(e) { console.error(e); }
})();

})();
